module.exports = __webpack_public_path__ + "static/halfway-cd7b3f8c8313e403b5bedbd925321b80.pdf";